export default "__VITE_ASSET__BsI5bGHM__"